import { handleResponse } from "../app/core/handleResponse";
import { ISetCartData, ISetCartCouponData, ISetCartItemInput } from "../features/cart/interfaces";

export default class CartAPI {
  static async deleteCart(token: string) {
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/cart?token=" + token,
      {
        method: "DELETE",
        headers: { "content-type": "application/json;charset=UTF-8" },
      }
    );
    return handleResponse(response);
  }

  static async removeCartCoupon(token: string) {
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/cart/coupons?token=" + token,
      {
        method: "DELETE",
        headers: { "content-type": "application/json;charset=UTF-8" },
      }
    );
    return handleResponse(response);
  }

  static async getCart(token: string) {
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/cart?token=" + token,
      {
        method: "GET",
        headers: { "content-type": "application/json;charset=UTF-8" },
      }
    );
    return handleResponse(response);
  }

  static async setCart(data: ISetCartData) {
    const response = await fetch(process.env.REACT_APP_SERVER_URL + "/cart", {
      method: "PUT",
      headers: { "content-type": "application/json;charset=UTF-8" },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  }

  static async updateCartCoupon(data: ISetCartCouponData) {
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/cart/coupons",
      {
        method: "POST",
        headers: { "content-type": "application/json;charset=UTF-8" },
        body: JSON.stringify({
          token: data.token,
          coupon: JSON.stringify(data.coupon),
        }),
      }
    );
    return handleResponse(response);
  }

  static async updateCartItem(data: ISetCartItemInput) {
    const response = await fetch(
      process.env.REACT_APP_SERVER_URL + "/cart_items",
      {
        method: "PUT",
        headers: { "content-type": "application/json;charset=UTF-8" },
        body: JSON.stringify(data),
      }
    );
    return handleResponse(response);
  }
}